/*
 * Copyright (c) 2025-2026 Terra Technology (Guangzhou) Co., Ltd.
 * Copyright (c) 2024-2026 山东艾坦迪数智科技有限公司.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

import { ModalForm, ModalFormProps } from "@ant-design/pro-components";
import React from 'react';

export type ProModalFormProps = Omit<ModalFormProps, 'children'> & {
  children?: React.ReactNode;
}
const ProModalForm = (props: ProModalFormProps) => {


  const { title, open, children, ...rest } = props;

  return (
    <ModalForm title={title}
      open={open}
      layout={'horizontal'}
      {...rest}
      className={'py-4 px-4'}
      modalProps={{
        centered: true,
        destroyOnHidden: true,
        ...rest.modalProps,
        styles: {
          ...rest.modalProps?.styles,
          body: {
            maxHeight: '80vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            ...rest.modalProps?.styles?.body,
          },
        },
      }}
    >
      {children}
    </ModalForm>
  )
};

export default ProModalForm;
